<div class="container appBg" *ngIf="!isMobile && isLoaded">
  <div class="bodyWrapper d-flex align-items-start justify-content-between">
    <div class="leftSection">
      <div class="page-container" [class.show]="currId == 0 || currId == 1"><app-banner></app-banner></div>
      <div class="page-container" [class.show]="currId == 2"><app-how-to-buy></app-how-to-buy></div>
      <div class="page-container" [class.show]="currId == 3"><app-about></app-about></div>
      <div class="page-container" [class.show]="currId == 4"><app-roadmap></app-roadmap></div>
      <div class="page-container" [class.show]="currId == 5"><app-tokenomics></app-tokenomics></div>
      <div class="page-container" [class.show]="currId == 6"><app-faq></app-faq></div>
    </div>
    <div class="rightSection">
      <app-widget></app-widget>
      <app-notification-purchase></app-notification-purchase>
    </div>
  </div>
</div>

<div class="container" *ngIf="isMobile && isLoaded">
  <app-banner></app-banner>
  <!-- <app-notification-purchase></app-notification-purchase> -->
  <app-about></app-about>
  <app-how-to-buy></app-how-to-buy>
  <app-roadmap></app-roadmap>
  <app-tokenomics></app-tokenomics>
  <app-faq></app-faq>
</div>